import React, { useState } from 'react';
import ModalContainer from '../../../components/ModalContainer';
import PaymentIcon from '@mui/icons-material/Payment';
import { IconButton } from '@mui/material';

const Information = ({ rowData }) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

    return (
        <>
        <span>
            <IconButton
            onClick={handleOpen}
            sx={{ mx: "0.25rem" }}
            >
                <PaymentIcon className="text-blue-500" />
            </IconButton>
        </span>
        <ModalContainer
            alwaysOpen={false}
            onClose={handleClose}
            isOpen={open}
            title={"اطلاعات بانکی"}
        >
            <div style={{ textAlign: 'center', display: 'flex', alignItems: 'center', flexDirection: 'column' }}>  
                <div style={{ display: 'flex', justifyContent: 'space-between', textAlign: 'right', width: '60%' }}>  
                    <p>شماره شبا</p>  
                    <p>
                        {rowData.contractor.shaba}
                    </p>  
                </div>  
                <div style={{ display: 'flex', justifyContent: 'space-between', textAlign: 'center', width: '60%', marginTop: '1rem' }}>  
                    <p>نام صاحب حساب</p>  
                    <p>{rowData.contractor.full_name} - {rowData.contractor.company_name}</p>
                </div>  
            </div> 
        </ModalContainer>
        </>
    );
}

export default Information;